import React from 'react';

import Popup from '../../Popup';
import styles from './welcomePopUps.scss';

const SearchPageReportsWelcomePopUp = ({
    onCloseClick,
    onCtaClick,
}) => {
    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.welcomePopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
            data-testid="modal.search-reports-welcome"
        >
            <div className={`${styles.section} pt0`}>
                <h4 data-testid="modal.search-reports-welcome.heading">
                        Welcome to the new search!
                    <span className="d-block" data-testid="modal.search-reports-welcome.heading-subtitle">
                            Apply advanced filters for finding players, colleges and more.
                    </span>
                </h4>
            </div>
            <div className={`${styles.section} pt0`}>
                <p data-testid="modal.search-reports-welcome.body-text">
                        Instead of the old Players and College reports in the menu, you can access advanced search at any time from the top of the website.
                </p>
                <div className="bb" />
                <button
                    type="button"
                    className="btn btn-primary btn-xl btn-block text-uppercase"
                    onClick={onCtaClick}
                    data-testid="modal.search-reports-welcome.got-it-btn"
                >
                        Got It
                </button>
            </div>
        </Popup>
    );
};

export default SearchPageReportsWelcomePopUp;
